import { Component, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { GS1ButtonDirective, GS1CardEventComponent, GS1ChipComponent, GS1CardEventConfig } from '@gs1france/gs1-components-library';
import { EventsService } from './services/events.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { TagsService } from '../../core/services/tags.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-home-events',
  imports: [TranslatePipe, GS1CardEventComponent, GS1ButtonDirective, GS1ChipComponent],
  templateUrl: './home-events.component.html',
  styleUrl: './home-events.component.scss'
})
export class HomeEventsComponent {
  eventsService = inject(EventsService);
  private tagsService = inject(TagsService);
  private breakpointObserver = inject(BreakpointObserver);

  events = toSignal(this.eventsService.getEvents(3));

  config = toSignal(
    this.breakpointObserver.observe('(max-width: 1440px)').pipe(
      map(({ matches }): GS1CardEventConfig => ({
        textMaxLines: 4,
        imageMaxHeight: '200px',
        imageHeight: '200px',
        type: matches ? 'image' : 'default'
      }))
    ),
    {
      initialValue: {
        textMaxLines: 4,
        imageMaxHeight: '200px',
        imageHeight: '200px',
        type: 'default'
      }
    }
  );

  checkEventFormat(format: string): boolean {
    const lowerFormat = format.toLocaleLowerCase();
    return lowerFormat.includes('distance') || lowerFormat.includes('webinaire');
  }

  trackEvent(title: string): void {
    this.tagsService.sendEvent('clic_agenda', { evenement: title });
  }

  trackAllEvents(): void {
    this.tagsService.sendEvent('clic_agenda', { evenement: 'Tous nos événements' });
  }
}
